import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/settings';

/**
 * TITA 扩展：出演已挂到艺人下面，菜单地址 /artist/perform
 * 旧地址 /perform 转到新地址
 */
const performRouter: RouteRecordRaw = {
  path: `${roterPre}/perform`,
  redirect: `${roterPre}/artist/perform`,
};

export default performRouter;
